<template>
  <!-- 使用记录 -->
  <div class="pop-room seal-log-pop" v-if="logStatus">
    <a href="javascript:;" @click="$emit('hideLog')" class="iconfont icon-close"></a>
    <h3 class="title">{{ sealName }}</h3>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="tabType">
        <el-radio-button label="0">使用记录</el-radio-button>
        <el-radio-button label="1">外带记录</el-radio-button>
      </el-radio-group>
    </div>

    <el-table :data="paginationData" style="width: 100%" v-loading="loading">
      <el-table-column label="使用人">
        <template slot-scope="scope">
          <user-info :userData='scope.row.user'></user-info>
        </template>
      </el-table-column>
      <el-table-column v-if="tabType=='0'" width="130px" prop="useTime" label="使用时间" :key="Math.random()"></el-table-column>

      <el-table-column v-if="tabType=='1'" width="130px" label="借出时间" :key="Math.random()">
        <template slot-scope="scope">
          {{ scope.row.takeTime ? scope.row.takeTime:'/' }}
        </template>
      </el-table-column>
      <el-table-column v-if="tabType=='1'" width="130px" label="归还时间" :key="Math.random()">
        <template slot-scope="scope">
          {{ scope.row.backTime ? scope.row.backTime:'/' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    props: ['logStatus', 'logSealId', 'sealName'],
    data() {
      return {
        loading: true,

        // 印章使用/外带记录
        // tabType: '0',
        logData: '',

        tabType: 0,
        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],
        filterKey: "",
      }
    },
    created() {
      if (this.logSealId) {
        // 获取列表
        this.getLists()
      }
    },
    methods: {
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选新闻数据
      getFilterData() {
        console.log(this.filterKey)
        if (this.filterKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _item = this.listData[i]

            if (_item.sealName.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1 ||
              _item.flow.creator.name.toLowerCase().indexOf(this.filterKey.toLowerCase()) != -1) {
              this.filterData.push(_item)
            }
          }
        } else {
          this.filterData = this.listData
        }
        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this.currentPage)
      },
      // 获取列表
      getLists() {
        this.loading = true
        let _url = this.tabType == '0' ? '/seal/use/log/' + this.logSealId : '/seal/take/log/' + this.logSealId

        ajax.get(_url, "", (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.array
          this.getPaginationData()
        })
      },
    },
    watch: {
      'logSealId'() {
        this.getLists()
      },
      'tabType'() {
        this.getLists()
      }
    }

  }
</script>


// WEBPACK FOOTER //
// src/page/seal/log.vue